export { BannerImageEntityMobile } from './banner-image';
